export const Barysaw = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.993653, 54.567859],
            [27.99651, 54.56405],
            [28.006795, 54.559743],
            [28.014223, 54.558418],
            [28.020223, 54.556098],
            [28.024794, 54.551625],
            [28.027079, 54.545825],
            [28.030222, 54.539693],
            [28.034793, 54.533561],
            [28.038221, 54.528753],
            [28.045363, 54.522453],
            [28.052791, 54.516981],
            [28.059362, 54.512171],
            [28.061648, 54.5062],
            [28.063933, 54.502219],
            [28.071932, 54.500394],
            [28.081075, 54.50056],
            [28.093074, 54.49973],
            [28.099073, 54.49691],
            [28.101644, 54.490273],
            [28.10193, 54.487452],
            [28.105644, 54.481477],
            [28.110501, 54.478157],
            [28.115929, 54.474672],
            [28.125642, 54.470521],
            [28.131356, 54.466703],
            [28.139355, 54.462053],
            [28.146498, 54.456573],
            [28.151069, 54.450926],
            [28.15364, 54.446109],
            [28.154497, 54.442454],
            [28.158497, 54.4383],
            [28.170496, 54.436473],
            [28.183923, 54.43531],
            [28.201922, 54.433316],
            [28.217349, 54.432485],
            [28.233633, 54.428663],
            [28.239918, 54.426834],
            [28.243918, 54.423677],
            [28.242775, 54.419521],
            [28.239061, 54.414035],
            [28.23649, 54.411375],
            [28.23649, 54.407218],
            [28.239918, 54.404225],
            [28.242204, 54.399735],
            [28.240775, 54.396908],
            [28.23449, 54.391585],
            [28.227919, 54.38909],
            [28.223063, 54.388258],
            [28.213635, 54.386096],
            [28.205921, 54.382602],
            [28.201636, 54.377777],
            [28.194208, 54.369456],
            [28.187923, 54.364463],
            [28.183923, 54.359302],
            [28.179923, 54.355473],
            [28.173924, 54.352643],
            [28.166496, 54.351478],
            [28.161354, 54.349812],
            [28.158211, 54.344484],
            [28.155068, 54.338821],
            [28.154497, 54.334324],
            [28.152783, 54.329493],
            [28.147926, 54.324662],
            [28.142784, 54.321496],
            [28.141927, 54.318163],
            [28.146783, 54.315997],
            [28.153354, 54.315664],
            [28.15764, 54.315664],
            [28.163925, 54.318497],
            [28.165639, 54.322329],
            [28.167067, 54.325661],
            [28.179638, 54.32816],
            [28.18678, 54.327494],
            [28.193065, 54.325328],
            [28.197636, 54.321829],
            [28.197636, 54.318996],
            [28.198208, 54.31633],
            [28.202207, 54.310831],
            [28.206778, 54.310831],
            [28.211349, 54.311997],
            [28.216777, 54.313331],
            [28.22392, 54.315497],
            [28.229634, 54.313664],
            [28.231633, 54.308497],
            [28.227348, 54.305163],
            [28.220206, 54.30233],
            [28.219063, 54.299162],
            [28.22392, 54.297161],
            [28.232776, 54.296328],
            [28.240775, 54.296828],
            [28.245347, 54.297495],
            [28.253346, 54.297828],
            [28.258488, 54.296161],
            [28.261345, 54.288991],
            [28.261345, 54.276816],
            [28.260202, 54.269977],
            [28.25506, 54.266973],
            [28.249632, 54.264471],
            [28.246489, 54.260132],
            [28.243061, 54.254124],
            [28.237919, 54.246947],
            [28.233062, 54.241271],
            [28.229062, 54.233424],
            [28.226491, 54.225241],
            [28.230112, 54.222519],
            [28.23249, 54.220731],
            [28.241061, 54.217558],
            [28.253346, 54.214216],
            [28.263916, 54.212212],
            [28.274773, 54.211209],
            [28.285057, 54.211209],
            [28.295057, 54.212713],
            [28.301056, 54.214885],
            [28.313912, 54.217892],
            [28.318483, 54.217892],
            [28.32734, 54.216221],
            [28.328482, 54.211711],
            [28.323626, 54.207199],
            [28.314769, 54.205027],
            [28.305342, 54.201685],
            [28.301056, 54.198176],
            [28.295628, 54.193329],
            [28.297628, 54.187813],
            [28.304484, 54.184302],
            [28.313341, 54.183132],
            [28.321054, 54.185807],
            [28.324768, 54.188147],
            [28.335339, 54.18915],
            [28.344481, 54.188816],
            [28.350766, 54.184636],
            [28.353337, 54.18146],
            [28.35448, 54.176611],
            [28.353052, 54.172598],
            [28.350195, 54.168919],
            [28.347052, 54.164068],
            [28.34591, 54.158214],
            [28.345624, 54.153028],
            [28.347909, 54.150852],
            [28.35848, 54.147841],
            [28.363051, 54.147339],
            [28.374479, 54.146669],
            [28.383049, 54.145665],
            [28.389334, 54.144996],
            [28.394477, 54.141649],
            [28.396477, 54.138302],
            [28.39562, 54.133615],
            [28.392477, 54.130435],
            [28.38762, 54.126082],
            [28.382192, 54.122734],
            [28.373907, 54.116539],
            [28.371872, 54.114519],
            [28.38232, 54.109559],
            [28.387295, 54.108572],
            [28.38962, 54.109672],
            [28.402191, 54.107998],
            [28.410476, 54.103475],
            [28.411047, 54.101297],
            [28.41419, 54.096104],
            [28.421332, 54.094596],
            [28.428188, 54.089737],
            [28.427331, 54.086889],
            [28.425617, 54.081358],
            [28.426189, 54.076163],
            [28.432474, 54.072642],
            [28.436188, 54.068954],
            [28.43076, 54.065098],
            [28.42276, 54.062416],
            [28.417332, 54.059565],
            [28.417046, 54.056044],
            [28.421332, 54.052354],
            [28.431331, 54.047826],
            [28.439616, 54.043464],
            [28.439616, 54.037593],
            [28.437616, 54.035076],
            [28.431617, 54.03172],
            [28.429331, 54.026518],
            [28.436759, 54.022826],
            [28.446187, 54.022826],
            [28.455329, 54.017959],
            [28.460471, 54.014266],
            [28.466471, 54.010908],
            [28.473899, 54.008558],
            [28.477327, 54.008894],
            [28.481898, 54.010908],
            [28.489897, 54.011748],
            [28.498468, 54.010908],
            [28.505325, 54.007215],
            [28.505039, 54.001506],
            [28.502468, 53.998819],
            [28.498754, 53.994789],
            [28.497325, 53.989918],
            [28.498754, 53.984543],
            [28.503039, 53.981855],
            [28.512753, 53.978327],
            [28.522122, 53.97649],
            [28.52618, 53.980007],
            [28.533894, 53.983871],
            [28.540179, 53.985718],
            [28.550464, 53.985551],
            [28.561891, 53.982695],
            [28.567034, 53.978159],
            [28.571891, 53.973958],
            [28.578176, 53.970429],
            [28.584461, 53.969757],
            [28.594174, 53.968413],
            [28.599317, 53.966396],
            [28.603031, 53.961858],
            [28.60703, 53.959169],
            [28.609602, 53.954966],
            [28.609887, 53.950932],
            [28.610459, 53.944879],
            [28.614173, 53.942188],
            [28.623315, 53.941179],
            [28.6316, 53.942861],
            [28.637028, 53.947569],
            [28.640171, 53.952781],
            [28.643027, 53.957824],
            [28.645884, 53.963203],
            [28.649027, 53.967236],
            [28.655598, 53.969253],
            [28.665026, 53.968749],
            [28.673025, 53.966564],
            [28.678167, 53.962362],
            [28.681881, 53.957656],
            [28.683222, 53.95542],
            [28.684203, 53.955933],
            [28.693577, 53.957246],
            [28.703397, 53.957772],
            [28.709647, 53.960661],
            [28.718128, 53.969589],
            [28.728842, 53.977203],
            [28.738662, 53.984553],
            [28.743573, 53.98954],
            [28.750268, 53.992427],
            [28.756072, 53.993476],
            [28.764999, 53.992952],
            [28.769463, 53.990327],
            [28.776606, 53.98954],
            [28.782855, 53.989802],
            [28.786873, 53.993476],
            [28.782409, 53.99715],
            [28.777945, 54.000299],
            [28.775713, 54.005021],
            [28.777945, 54.010268],
            [28.781069, 54.014203],
            [28.781516, 54.018399],
            [28.778391, 54.022071],
            [28.778391, 54.024955],
            [28.784194, 54.027315],
            [28.788212, 54.027577],
            [28.794908, 54.029151],
            [28.799818, 54.032821],
            [28.803389, 54.038327],
            [28.80696, 54.042259],
            [28.814995, 54.045666],
            [28.821691, 54.04619],
            [28.82928, 54.044355],
            [28.833297, 54.04121],
            [28.834636, 54.038851],
            [28.836868, 54.037278],
            [28.846689, 54.035443],
            [28.85651, 54.037278],
            [28.863205, 54.039899],
            [28.870794, 54.041734],
            [28.880168, 54.043045],
            [28.910969, 54.043307],
            [28.932842, 54.043045],
            [28.947127, 54.043045],
            [28.958287, 54.045404],
            [28.971679, 54.048549],
            [28.987749, 54.051956],
            [28.999355, 54.05379],
            [29.006184, 54.053991],
            [29.002926, 54.06427],
            [28.997123, 54.075534],
            [28.993552, 54.087318],
            [28.99132, 54.101455],
            [28.989981, 54.113231],
            [28.988195, 54.118726],
            [28.979714, 54.119772],
            [28.970339, 54.120296],
            [28.964536, 54.121342],
            [28.964536, 54.125789],
            [28.967661, 54.128144],
            [28.972571, 54.131021],
            [28.986142, 54.132444],
            [28.991284, 54.135791],
            [28.984999, 54.138637],
            [28.979285, 54.139139],
            [28.973857, 54.141482],
            [28.974143, 54.144661],
            [28.977857, 54.150852],
            [28.978142, 54.16089],
            [28.979571, 54.173099],
            [28.979856, 54.178618],
            [28.976142, 54.182296],
            [28.971, 54.183132],
            [28.966429, 54.183132],
            [28.959287, 54.184135],
            [28.951287, 54.186642],
            [28.947859, 54.189819],
            [28.951002, 54.192827],
            [28.955001, 54.195502],
            [28.957001, 54.197006],
            [28.957573, 54.200348],
            [28.957001, 54.205027],
            [28.952144, 54.209539],
            [28.945859, 54.213381],
            [28.943574, 54.219228],
            [28.93586, 54.221733],
            [28.929004, 54.222068],
            [28.916147, 54.222736],
            [28.903577, 54.224239],
            [28.891578, 54.227245],
            [28.88615, 54.230919],
            [28.885007, 54.236262],
            [28.882722, 54.240436],
            [28.878151, 54.243441],
            [28.872437, 54.246446],
            [28.868151, 54.249952],
            [28.867866, 54.253791],
            [28.873294, 54.257295],
            [28.880722, 54.259798],
            [28.886721, 54.260466],
            [28.889293, 54.262802],
            [28.891007, 54.270477],
            [28.887007, 54.274648],
            [28.876151, 54.278151],
            [28.873294, 54.282487],
            [28.873865, 54.287324],
            [28.877865, 54.290325],
            [28.882722, 54.292826],
            [28.889578, 54.295661],
            [28.896435, 54.299162],
            [28.899577, 54.30333],
            [28.896149, 54.30783],
            [28.889578, 54.307997],
            [28.878151, 54.30733],
            [28.871294, 54.308164],
            [28.865295, 54.311331],
            [28.860724, 54.316664],
            [28.859009, 54.321329],
            [28.859295, 54.325661],
            [28.861009, 54.33016],
            [28.861866, 54.339987],
            [28.859009, 54.345649],
            [28.856438, 54.351311],
            [28.863009, 54.356139],
            [28.865866, 54.357305],
            [28.86958, 54.362299],
            [28.871294, 54.366959],
            [28.87158, 54.371952],
            [28.868723, 54.37578],
            [28.86758, 54.381936],
            [28.867009, 54.387593],
            [28.865009, 54.393581],
            [28.859581, 54.395078],
            [28.850439, 54.394579],
            [28.842439, 54.393082],
            [28.835868, 54.392417],
            [28.825584, 54.393415],
            [28.814727, 54.397074],
            [28.814727, 54.402396],
            [28.824441, 54.404225],
            [28.831869, 54.408216],
            [28.833012, 54.411708],
            [28.825584, 54.41603],
            [28.819584, 54.416363],
            [28.809585, 54.416363],
            [28.800443, 54.413869],
            [28.792444, 54.409047],
            [28.784159, 54.407551],
            [28.781302, 54.408216],
            [28.778159, 54.412206],
            [28.782444, 54.414534],
            [28.78473, 54.419022],
            [28.785016, 54.424175],
            [28.784444, 54.428663],
            [28.786444, 54.433648],
            [28.791301, 54.435143],
            [28.796157, 54.438134],
            [28.797586, 54.442786],
            [28.789872, 54.445112],
            [28.78073, 54.44777],
            [28.77216, 54.450926],
            [28.77016, 54.456407],
            [28.770445, 54.459728],
            [28.771874, 54.464544],
            [28.782159, 54.467367],
            [28.792158, 54.469027],
            [28.801586, 54.469027],
            [28.811585, 54.468529],
            [28.821013, 54.465706],
            [28.826726, 54.462717],
            [28.83244, 54.461223],
            [28.84044, 54.461223],
            [28.84901, 54.462717],
            [28.858438, 54.466038],
            [28.869009, 54.469525],
            [28.875294, 54.473842],
            [28.878436, 54.480979],
            [28.878722, 54.489111],
            [28.880722, 54.493592],
            [28.887007, 54.49774],
            [28.891578, 54.503048],
            [28.889007, 54.508854],
            [28.882722, 54.511674],
            [28.873294, 54.514659],
            [28.859581, 54.518971],
            [28.85301, 54.521624],
            [28.851867, 54.525769],
            [28.858152, 54.527924],
            [28.86758, 54.534224],
            [28.871865, 54.539693],
            [28.875579, 54.544997],
            [28.878151, 54.551625],
            [28.879865, 54.560406],
            [28.87966, 54.563021],
            [28.872522, 54.562101],
            [28.866226, 54.559778],
            [28.858785, 54.556459],
            [28.84562, 54.555463],
            [28.828447, 54.555463],
            [28.816427, 54.557123],
            [28.81242, 54.560774],
            [28.808413, 54.566416],
            [28.802117, 54.572057],
            [28.790097, 54.57272],
            [28.785517, 54.575375],
            [28.776931, 54.577365],
            [28.76949, 54.574379],
            [28.764338, 54.569734],
            [28.75747, 54.56542],
            [28.746022, 54.566084],
            [28.729422, 54.563097],
            [28.709388, 54.562101],
            [28.699085, 54.562765],
            [28.690499, 54.566747],
            [28.680195, 54.573716],
            [28.676189, 54.579688],
            [28.68134, 54.588312],
            [28.686492, 54.591629],
            [28.693933, 54.599919],
            [28.691071, 54.60423],
            [28.686492, 54.609202],
            [28.68134, 54.615501],
            [28.672754, 54.623455],
            [28.660161, 54.633395],
            [28.65501, 54.639027],
            [28.65501, 54.644327],
            [28.653293, 54.65062],
            [28.645851, 54.654262],
            [28.637838, 54.658236],
            [28.625994, 54.658945],
            [28.621238, 54.659229],
            [28.602349, 54.658236],
            [28.586894, 54.653931],
            [28.577735, 54.651944],
            [28.569722, 54.649626],
            [28.558846, 54.649626],
            [28.534233, 54.65062],
            [28.512482, 54.650289],
            [28.484434, 54.651282],
            [28.473558, 54.647639],
            [28.464972, 54.642671],
            [28.4644, 54.635714],
            [28.4644, 54.629088],
            [28.462683, 54.618815],
            [28.46211, 54.611854],
            [28.460393, 54.601577],
            [28.455241, 54.589307],
            [28.450662, 54.580683],
            [28.444366, 54.573384],
            [28.437497, 54.565088],
            [28.430056, 54.556459],
            [28.420325, 54.548492],
            [28.412884, 54.542515],
            [28.402581, 54.540855],
            [28.399718, 54.545503],
            [28.383119, 54.547163],
            [28.375678, 54.546499],
            [28.368809, 54.549487],
            [28.364802, 54.555131],
            [28.364802, 54.561106],
            [28.36423, 54.567411],
            [28.36194, 54.571725],
            [28.359078, 54.583337],
            [28.353926, 54.586985],
            [28.342478, 54.58798],
            [28.335609, 54.58798],
            [28.332175, 54.591629],
            [28.332175, 54.594614],
            [28.324161, 54.601246],
            [28.306417, 54.600251],
            [28.299548, 54.59793],
            [28.291535, 54.600914],
            [28.289245, 54.606882],
            [28.278942, 54.612517],
            [28.277224, 54.618484],
            [28.277797, 54.625112],
            [28.278369, 54.633727],
            [28.270356, 54.638696],
            [28.26177, 54.639358],
            [28.249177, 54.640021],
            [28.244598, 54.642008],
            [28.238874, 54.647308],
            [28.234867, 54.651282],
            [28.222274, 54.655256],
            [28.207964, 54.657574],
            [28.205688, 54.657386],
            [28.19995, 54.656911],
            [28.190219, 54.654262],
            [28.176482, 54.651282],
            [28.170185, 54.65062],
            [28.160455, 54.648964],
            [28.151868, 54.645983],
            [28.144427, 54.63969],
            [28.140993, 54.63472],
            [28.138131, 54.628425],
            [28.127828, 54.625112],
            [28.108938, 54.625112],
            [28.103787, 54.620804],
            [28.090049, 54.616495],
            [28.07116, 54.613843],
            [28.062001, 54.610528],
            [28.048264, 54.604561],
            [28.04254, 54.599256],
            [28.036816, 54.594282],
            [28.033381, 54.590634],
            [28.021933, 54.583668],
            [28.018499, 54.582673],
            [28.01163, 54.582673],
            [28.007051, 54.584995],
            [28.006581, 54.585812],
            [28.006509, 54.585743],
            [28.001938, 54.581438],
            [27.998224, 54.57763],
            [27.994796, 54.572994],
            [27.993653, 54.567859],
          ],
        ],
      },
      properties: {
        shapeName: "Barysaw",
        shapeISO: "",
        shapeID: "67162791B39606099444015",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
